import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/global.css'
// 去除按需加载代码
import './plugins/vant.js'
import 'vant/lib/icon/local.css'
import axios from 'axios'
import store from './store'
import wx from 'weixin-js-sdk'
import qs from 'qs'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import {
  VueJsonp
} from 'vue-jsonp'
axios.defaults.baseURL = window.location.href.split("/#")[0];
// 'https://api.rhdki.com/' 
axios.interceptors.request.use(config => {
  config.headers.Authorization = window.localStorage.getItem('token')
  return config
})
axios.defaults.timeout = 50000
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.transformRequest = [obj => Qs.stringify(obj)]
Vue.prototype.$http = axios
Vue.prototype.$wx = wx
Vue.prototype.$cookies = VueCookies
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe']
Vue.prototype.$qs = qs
Vue.use(VueClipboard)
Vue.use(VueJsonp)
new Vue({
  router,
  store,
  wx,
  render: h => h(App)
}).$mount('#app')
